import { yupResolver } from "@hookform/resolvers/yup";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { UserContext } from "../../../contexts/UserContext";
import * as yup from "yup";
import animeLoading from "../../../public/lottie/14117-crypto-loader.json";
import Lottie from "react-lottie";
import useImageUpload from "../../../hooks/helper/useImageUpload";
import { Tile } from "../../../models/bluetile";
import { TilesContext } from "../../../contexts/TilesContext";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Image from "next/image";
import WalletChoooser from "../../wallet/wallet-chooser";
import { ethers } from "ethers";
import { tagMintBlueTile } from "../../../lib/events";
import { fleatoConfig } from "../../../fleato-config";
import { Product, Variation, VariationOption } from "../../../models/product";
import useProduct from "../../../hooks/product/useProduct";
import { useRouter } from "next/router";
import { TilesWrapper } from "../style";
import { getCurrentLength, getMaxLength, getNLengthArray, words } from "../bluetile-helpers";
import html2canvas from "html2canvas";
import { randomShortUrl } from "../../../util/util";

interface Props {
  handleActiveTab: (value: string) => void;
  tilesImage: string;
  merchImage?: string;
  selectedTileType: string;
  resetTiles: (showAlert: boolean) => void;
  tiles: Tile[];
  merchandise: Variation;
  pickSize: string;
  setPickSize: (a: string) => void;
  setSelectedColor: (a: string) => void;
  selectedColor: string;
  merchandiseOption: VariationOption;
  product: Product;
  tileWords: string[];
  setTilesImage: (a: any) => void;
  mint: (title: string, wallet: string, totalSupply: number, imageUrl: string, selectedTileType: string, merchImageUrl?: string) => Promise<void>;
}
function QuantitySelector({ handleActiveTab, tilesImage, resetTiles, tiles, merchImage, selectedTileType, merchandise, selectedColor, setPickSize, setSelectedColor, pickSize, merchandiseOption, product, tileWords, setTilesImage, mint }: Props) {
  const { isAuthenticated, hasFleatoWallet } = useContext(UserContext);
  const { uploadBase64toStorage } = useImageUpload();
  const [tileWidth, setTileWidth] = useState(0);
  const router = useRouter();
  const { buyNow } = useProduct(product?.id);
  const [readyToListNonNFT, setReadyToListNonNFT] = useState(false);
  const [loading, setLoading] = useState(false);
  const { name, exists, allowance } = useContext(TilesContext);
  const SwalAlert = withReactContent(Swal);
  const [wallet, setWallet] = useState<string>(undefined);
  const [wordsImage, setWordsImage] = useState<string>(undefined);
  interface FormData {
    quantity: number
  }
  const installCost = () => {
    let base = 219, additional = 0, costPer3To17Char = 15;
    if (selectedTileType == 'shapes')
      additional = 0;
    else if(!tileWords?.length || tileWords?.length <= 2)
      additional = 0;
    else if(tileWords?.length > 2)
      additional = Math.min(15, tileWords.length - 2) * costPer3To17Char;
    else 
      additional = 0;
    return base + additional;
  }

  let tilePrice = `${selectedTileType == 'shapes' ? 49 : (tileWidth * 7 * product?.listing?.buyNowPrice)} ${merchandise?.sku === "tile-and-installation" ? `+ $${installCost()} installation fee` : ''}`;

  useEffect(() => {
    if(selectedTileType === "words" && tileWidth === 0){
      let tileWidths = [];
      let tileWidth1 = 0;
      const totalLines = tileWords?.filter(item => item === "\n")?.length;
      for (let i = 0; i < tileWords?.length; i++) {
        if(tileWords?.[i] === "\n" || i === tileWords?.length - 1){
          tileWidth1 = tileWidth1 + words?.[tileWords?.[i].toUpperCase()]?.width;
          tileWidths?.push(tileWidth1);
          tileWidth1 = 0;          
        }else {
          tileWidth1 = tileWidth1 + words?.[tileWords?.[i].toUpperCase()]?.width;
        }
      }
      if(tileWidths?.length === 1){
        setTileWidth(tileWidths?.[0] + 1);
      }else {
        setTileWidth(tileWidths?.sort((a, b) => a > b ? -1 : 1)?.[0] * tileWidths?.length);
      }
    }
  }, [tileWords, selectedTileType])

  const onSubmit = async (data: FormData) => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
    setLoading(true);
    if (selectedTileType == 'shapes') {
      // const taken = await exists();
      // const error = taken[0] && taken[1] ? "Oops, both the pattern and the name is taken" :
      //   taken[0] ? "OOps, that pattern is taken" :
      //     taken[1] ? "Oops, that name is taken" : null;
      // if (error) {
      //   SwalAlert.fire({
      //     title: <h3>{error}</h3>,
      //     html: <p>Please continue building.</p>,
      //     confirmButtonText: "Ok",
      //     confirmButtonColor: "#1478DD"
      //   });
      //   setLoading(false);
      //   return;
      // }
      // const lives = await allowance();
      // if (lives == 0) {
      //   SwalAlert.fire({
      //     title: <h3>Oops, you already used up your allowance!</h3>,
      //     html: <p>You will earn additional allowance as you engage with the blue tile project. We will keep you posted.</p>,
      //     confirmButtonText: "Ok",
      //     confirmButtonColor: "#1478DD"
      //   });
      //   setLoading(false);
      //   return;
      // }
      setReadyToListNonNFT(true);
      if (!isAuthenticated) {
        handleActiveTab('showLogin');
        setLoading(false);
        return;
      }
      const uploadedImage = await uploadBase64toStorage(tilesImage, "bluetileproject", randomShortUrl(), "png");

      //If user didnt make choice about wallet, and simply clicked mint, the wallet will be undefined.
      // await mint(name, wallet ?? ethers.constants.AddressZero, data.quantity, uploadedImage?.url, selectedTileType);
      // tagMintBlueTile(name, wallet ?? ethers.constants.AddressZero, !wallet || wallet === ethers.constants.AddressZero ? "nowallet" : "fleato", fleatoConfig.maticChainId as any);
      const orderHeaderId = await buyNow({
        productId: product.id, variationSku: merchandise?.sku,
        quantity: data.quantity,
        variationOptionSku: merchandiseOption?.sku, createNewOrderheader: true, customizationOption: [], printfulData: {
          image: uploadedImage?.url,
          width: tileWidth,
          quantity: data.quantity,
          merchImage: merchandise?.image,
          tiles,
          tileWords,
          selectedTileType,
        }
      });
      if (orderHeaderId) router.push(`/checkout/${orderHeaderId}`);
      // handleActiveTab('listed');
      resetTiles(false);
      setLoading(false);
    }
    else {
      setReadyToListNonNFT(true);
      if (!isAuthenticated) {
        handleActiveTab('showLogin');
        setLoading(false);
        return;
      }
      const uploadedImage = await uploadBase64toStorage(wordsImage, "bluetileproject", randomShortUrl(), "png");
      // await mint(name, wallet ?? ethers.constants.AddressZero, data.quantity, uploadedImage?.url, merchandiseOption?.image, selectedTileType);
      const orderHeaderId = await buyNow({
        productId: product.id, variationSku: merchandise?.sku, variationOptionSku: merchandiseOption?.sku,
        quantity: data.quantity,
        createNewOrderheader: true, customizationOption: [], printfulData: {
          image: uploadedImage?.url,
          width: tileWidth,
          quantity: data.quantity ?? 1,
          merchImage: merchImage,
          tiles,
          tileWords,
          selectedTileType,
        }
      });
      if (orderHeaderId) router.push(`/checkout/${orderHeaderId}`);
      // handleActiveTab('listed');
      resetTiles(false);
      setLoading(false);
    }
  }


  const schema = yup
    .object({
      quantity: yup.number().min(1).max(1000000000).required("Quantity is a required field"),
    })
    .required();

  // const { mint, tokenId } = useContext(TilesContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: { quantity: 1 },
  }); //

  const charWidth = (value: string) => words?.[value.toUpperCase()]?.width ?? 5;

  const charStyle = (value: string) => {
    if (value == "\n") return "";
    else {
      switch (charWidth(value)) {
        case 2: return "two-tiles-container";
        case 3: return "three-tiles-container";
        case 4: return "four-tiles-container";
        case 5: return "five-tiles-container";
        case 6: return "six-tiles-container";
        case 7: return "seven-tiles-container";
        case 8: return "eight-tiles-container";
        default: return "tiles-container";
      }
    }
  };

  useEffect(() => {
    if (!!!wordsImage && selectedTileType == 'words') {
      (async () => {
        await convertTiles();
      })()
    }
  }, [wordsImage, selectedTileType])

  const convertTiles = async () => {
    html2canvas(document.getElementById('final-tile-container')).then(function (canvas) {
      setWordsImage(canvas.toDataURL());
    });
  }

  return (
    <>
      {loading && (
        <div className="col-12  ps-md-2 bg-none white-bg">
          <Lottie
            height={200}
            width={200}
            options={{
              loop: true,
              autoplay: true,
              animationData: animeLoading,
            }}
          />
        </div>
      )}
      {!loading && !readyToListNonNFT && <div className="container py-5 mx-auto my-md-5 my-lg-4 border rounded p-3 p-lg-5">
        {selectedTileType == "words" ? <div className="w-100 overflow-x-md-scroll">
          <TilesWrapper>
            <div className="my-2">
              <div id='tile-preview'>
                {/* gridTemplateColumns: `repeat(${getMaxLength(tileWords)},15px)` */}
                {tileWords?.length > 0 && <div id="final-tile-container" className='tiles-container' style={{ overflow: "visible", }}>
                  <div>
                    {tileWords?.map((value, index) => <>
                      <div key={`${index}`} className={`${charStyle(value)} ${value != '\n' ? 'float-left' : 'clear-left'} border-left`}>
                        {value != '\n' && words?.[value.toUpperCase()]?.coordinates?.map((item, index) => {
                          return <div key={`${index}`} className={`tile overflow-hidden ${item <= 5 ? 'bg-white' : 'bg-blue'} `}>
                            <div className={`${item == 1 ? 'blue-tile'
                              : item == 2 ? 'blue-tile-top'
                                : item == 3 ? 'blue-tile-right'
                                  : item == 4 ? 'blue-tile-bottom'
                                    : item == 5 ? 'blue-tile-left'
                                      : item == 6 ? 'v-white-tile-top'
                                        : item == 7 ? 'v-white-tile-right'
                                          : item == 8 ? 'v-white-tile-bottom'
                                            : item == 9 ? 'v-white-tile-left'
                                              : 'white-tile'
                              }`}>
                            </div>
                          </div>
                        })}
                      </div>
                      {(tileWords?.[index + 1] == '\n' || index + 1 === tileWords?.length) && getCurrentLength(tileWords, index + 1) != getMaxLength(tileWords) && getNLengthArray(getMaxLength(tileWords) - getCurrentLength(tileWords, index + 1))?.map((item, index) => {
                        return <div key={index} className=' end-tiles-container1 float-left'>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                          <div className='tile overflow-hidden bg-white'></div>
                        </div>
                      })}
                      {tileWords?.[index + 1] == '\n' && <div className=' end-tiles-container float-left'>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                        <div className='tile overflow-hidden bg-white'></div>
                      </div>}
                    </>
                    )}
                    {tileWords?.length ? <div className='end-tiles-container float-left'>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                      <div className='tile overflow-hidden bg-white'></div>
                    </div> : null}
                  </div>
                </div>}
              </div>
            </div>
          </TilesWrapper>
        </div> : null}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group row mb-0 position-relative">
            <div className="col-lg-6">
              <label className="col-form-label fw-bold ">
                Your unique Blue Tile<span className='fw-bold'>*</span>
              </label>
              <p>Congratulations, you have designed your Blue Tile. Here is a quick preview</p>
              <p className="text-blue cursor-pointer" onClick={() => handleActiveTab('createTile')}>Make more edits</p>
            </div>

            <div className="col-sm-6 overflow-hidden">
              {merchandiseOption ? <Image src={merchandiseOption?.image} width={100} height={100} /> : null}
              {selectedTileType == "shapes" && <div className="w-100 position-relative" style={{ height: 300 }}>
                <Image src={tilesImage} width={300} height={300} alt={'tile-image'} objectFit='contain' />
              </div>}
            </div>
          </div>
          <div className=" row mb-4 mt-lg-2 mb-lg-0">
            <div className="col-lg-6">
              <label className="col-form-label fw-bold ">
                Select Order Quantity <span className='fw-bold'>*</span>
              </label>
              <p>(${merchandiseOption ? merchandiseOption?.price.toFixed(2) : !["tile-and-installation", "blue-tile-project-merchandise-1670535097265"].includes(merchandise?.sku) ? merchandise?.price?.toFixed(2) : tilePrice} each)</p>
              {/* <p>Make a single copy just for yourself (super rare collectible), or a million copies to share with everyone. Choose wisely, it is final, and this exact pattern cannot be minted ever again by anyone.</p> */}
            </div>
            <div className=" col-lg-6">
              <input
                type="number"
                step={1}
                className="form-control"
                name="quantity"
                {...register("quantity")}
              />
              {errors.quantity?.message ? <p className={"text-error"}>
                {errors.quantity?.message}
              </p> : null}
            </div>
          </div>
          {merchandise?.options?.length > 1 &&
            <div className="my-2 col-lg-6 col-md-12 col-sm-12">
              {[...new Set(merchandise?.options?.map(o => o.size))].length > 1 &&
                <div className="col">
                  <p className="fw-bold">Select size</p>
                  <select
                    className="form-select my-2"
                    value={pickSize}
                    onChange={(e) => {
                      setPickSize(e.target.value)
                    }}
                  >
                    <option key={"choose size"} value={null}>Choose Size</option>
                    {[...new Set(merchandise?.options?.map(o => o.size))].map(size =>
                      <option key={size} value={size}>{size}</option>)}
                  </select>
                </div>
              }
              {[...new Set(merchandise?.options?.map(o => o.colorCode))].length > 1 &&
                <div className="col">
                  <p className="fw-bold">Select color</p>
                  <div className="border p-1 d-flex flex-wrap" >

                    {[...new Set(merchandise?.options?.map(o => o.colorCode))].map((value) => {
                      return <div key={`${value}`}
                        className="rounded m-1"
                        style={{ width: 20, height: 20, backgroundColor: `${value}`, border: selectedColor == value ? `3px solid #d2d2d2` : '2px solid #f1f1f1', }}
                        onClick={() => {
                          setSelectedColor(value);
                        }}>
                      </div>
                    })}
                  </div>
                </div>
              }
            </div>
          }
          <>
            {/* <div className="form-group row mb-0">
              <div className="col-lg-6">
                <label className="col-form-label fw-bold ">
                  Get your Blue Tile in your Own Wallet<span className='fw-bold'> (Optional)</span>
                </label>
                <p>Create a Digital Wallet to hold your Blue Tile Art. Or, you could do that later and we will hold it for you.</p>
              </div>
              <div className="col-sm-6">
                <WalletChoooser selectWallet={setWallet} />
              </div>
            </div> */}
          </>
          <div className="col-10 col-md-8 col-lg-4 d-flex flex-column flex-md-row align-items-center justify-content-md-between mx-auto mt-5">

            <button
              className="mb-2 mb-md-0 mx-3 btn btn-primary bg-white text-black d-flex align-items-center justify-content-center py-3 px-3  w-100"
              onClick={() => handleActiveTab('createTile')}
            >
              {" "}
              Back
            </button>

            <button
              className="mb-2 mb-md-0 mx-3 btn btn-primary px-2 py-3  w-100"
              type="submit"
            >
              Buy
            </button>
          </div>

        </form>
      </div>}
    </>
  );
}

export default QuantitySelector;


